import analyticsAdapter from './analyticsAdapter';

// Create and export the global plugIns instance
// This instance will be initialized in App.vue
export const plugIns = new analyticsAdapter.Adapter({
  env: process.env
});

// export existing name to minimize code changes
export const plugInAdapter = analyticsAdapter;
